module.exports = __webpack_public_path__ + "img/voting-one-and-two-dude.a05463e6.svg";